/**
 * Bright Ideas: product page layout (works on every product template).
 * - Feature tags under the title (same tags as the product cards)
 * - Moves the service options above the Add to basket button, as in the draft
 * - "Call us" / "Ask a question" buttons under Add to basket
 * - Splits the description list into Highlights (in the buy column) and a
 *   Key specifications table below, next to "Why buy from Bright Ideas"
 * Nothing is removed from the page's forms, so the service add-on script and
 * the Enquire Now buttons keep working exactly as before.
 */
(function () {
  var PHONE = '01937 585646';
  var ENQUIRY_URL = '/pages/enquiry-page';
  var SPEC_PREVIEW = 12;

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function data() {
    var tag = document.getElementById('bi-pdp-data');
    if (!tag) return null;
    try { return JSON.parse(tag.textContent); } catch (e) { return null; }
  }
  // The info column's direct child that holds a given element
  function blockOf(info, node) {
    while (node && node.parentElement !== info) node = node.parentElement;
    return node;
  }

  function addChips(info, p) {
    if (!p || !window.BICards || info.querySelector('.bi-pdp-chips')) return;
    var tags = [];
    try { tags = window.BICards.chips(p) || []; } catch (e) { tags = []; }
    if (!tags.length) return;
    var title = info.querySelector('.product__title');
    if (!title) return;
    var ul = el('ul', 'bi-pdp-chips');
    ul.setAttribute('aria-label', 'Key features');
    tags.forEach(function (t) { ul.appendChild(el('li', '', esc(t))); });
    title.insertAdjacentElement('afterend', ul);
  }

  function moveServices(info) {
    var svc = info.querySelector('.service-addons');
    if (!svc || svc.dataset.biMoved) return;
    var qty = info.querySelector('.product-form__quantity');
    var buy = info.querySelector('product-form');
    var target = blockOf(info, qty || buy);
    var svcBlock = blockOf(info, svc);
    if (!target || !svcBlock || target === svcBlock) return;
    // Only move it up (from below the button), never past the price
    if (target.compareDocumentPosition(svcBlock) & Node.DOCUMENT_POSITION_FOLLOWING) {
      info.insertBefore(svcBlock, target);
    }
    svc.dataset.biMoved = '1';
  }

  function addContact(info) {
    if (info.querySelector('.bi-pdp-contact')) return;
    var enquire = info.querySelector('.onhow-custom-btn');
    var buy = info.querySelector('product-form');
    var after = blockOf(info, enquire || buy);
    if (!after) return;
    var wrap = el('div', 'bi-pdp-contact');
    var phoneIcon = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z"/></svg>';
    var askIcon = '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>';
    wrap.innerHTML = '<a href="tel:' + PHONE.replace(/\s/g, '') + '">' + phoneIcon + '<span>Call ' + PHONE + '</span></a>';
    // Products that already have an "Enquire Now" button don't need a second one
    if (!enquire) {
      wrap.innerHTML += '<a href="' + ENQUIRY_URL + '">' + askIcon + '<span>Ask a question</span></a>';
    } else {
      wrap.classList.add('bi-pdp-contact--single');
    }
    after.insertAdjacentElement('afterend', wrap);
  }

  function splitDescription(info) {
    var desc = info.querySelector('.product__description');
    if (!desc || desc.dataset.biDone) return null;
    desc.dataset.biDone = '1';
    var specs = [];
    var highlights = [];
    var lists = Array.prototype.slice.call(desc.querySelectorAll('ul'));
    lists.forEach(function (ul) {
      var items = Array.prototype.slice.call(ul.children).filter(function (li) { return li.tagName === 'LI'; });
      if (!items.length) return;
      var all = true;
      items.forEach(function (li) {
        var text = li.textContent.replace(/\s+/g, ' ').trim();
        if (!text) return;
        var i = text.indexOf(':');
        if (i > 0 && i < 60 && text.slice(i + 1).trim()) {
          specs.push([text.slice(0, i).trim(), text.slice(i + 1).trim()]);
        } else if (text.length <= 140) {
          highlights.push(text);
        } else {
          all = false;
        }
      });
      if (all) ul.classList.add('bi-pdp-converted');
    });
    // Too few spec lines: leave the description as it is
    if (specs.length < 3) {
      lists.forEach(function (ul) { ul.classList.remove('bi-pdp-converted'); });
      return null;
    }
    lists.forEach(function (ul) { if (ul.classList.contains('bi-pdp-converted')) ul.style.display = 'none'; });
    // If nothing else is left in the description, hide the empty box
    var rest = desc.cloneNode(true);
    Array.prototype.slice.call(rest.querySelectorAll('.bi-pdp-converted')).forEach(function (n) { n.remove(); });
    var hasMedia = rest.querySelector('img, iframe, video, table');
    if (!rest.textContent.trim() && !hasMedia) desc.classList.add('bi-pdp-moved');

    if (highlights.length) {
      var box = el('div', 'bi-pdp-highlights');
      box.innerHTML = '<h2>Highlights</h2><ul>' + highlights.slice(0, 8).map(function (h) {
        return '<li>' + esc(h) + '</li>';
      }).join('') + '</ul>';
      desc.insertAdjacentElement('beforebegin', box);
    }
    return specs;
  }

  function addDetails(info, specs) {
    var section = info.closest('.shopify-section');
    if (!section || document.querySelector('.bi-pdp-details')) return;
    var specHTML = '';
    if (specs && specs.length) {
      specHTML = '<div class="bi-pdp-details__specs"><h2 id="bi-specs-title">Key specifications</h2>' +
        '<dl class="bi-specs" aria-labelledby="bi-specs-title">' +
        specs.map(function (s, i) {
          var hide = i >= SPEC_PREVIEW ? ' hidden' : '';
          return '<dt' + hide + '>' + esc(s[0]) + '</dt><dd' + hide + '>' + esc(s[1]) + '</dd>';
        }).join('') + '</dl>' +
        (specs.length > SPEC_PREVIEW
          ? '<button type="button" class="bi-specs-toggle" aria-expanded="false">Show all ' + specs.length + ' specifications</button>'
          : '') +
        '</div>';
    }
    var why = '<div class="bi-pdp-details__why"><h2>Why buy from Bright Ideas</h2><ul class="bi-why">' +
      '<li><strong>Fitted by our own family team</strong><span>Add installation and it is fitted by the same people who sold it to you.</span></li>' +
      '<li><strong>Over 30 years in Wetherby</strong><span>Local, independent and here after you buy.</span></li>' +
      '<li><strong>Talk to a real person</strong><span>Questions about sizes or fitting? Call <a href="tel:' + PHONE.replace(/\s/g, '') + '">' + PHONE + '</a>.</span></li>' +
      '</ul></div>';
    var wrap = el('div', 'bi-pdp-details page-width', '<div class="bi-pdp-details__grid">' + specHTML + why + '</div>');
    section.insertAdjacentElement('afterend', wrap);

    var btn = wrap.querySelector('.bi-specs-toggle');
    if (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        Array.prototype.slice.call(wrap.querySelectorAll('.bi-specs dt, .bi-specs dd')).forEach(function (n, i) {
          if (i >= SPEC_PREVIEW * 2) n.hidden = open;
        });
        btn.setAttribute('aria-expanded', String(!open));
        btn.textContent = open ? 'Show all ' + specs.length + ' specifications' : 'Show fewer specifications';
      });
    }
  }

  // "Add to cart" -> "Add to basket", matching the Basket link in the header.
  // The theme re-writes this label when the variant changes, so change its wording too.
  function basketLabel(info) {
    if (window.variantStrings && window.variantStrings.addToCart === 'Add to cart') {
      window.variantStrings.addToCart = 'Add to basket';
    }
    Array.prototype.slice.call(info.querySelectorAll('.product-form__submit span')).forEach(function (s) {
      if (s.textContent.trim() === 'Add to cart') s.textContent = 'Add to basket';
    });
  }

  function boot() {
    var main = document.querySelector('main[data-template^="product"]');
    if (!main) return;
    var info = main.querySelector('.product__info-container');
    if (!info) return;
    var p = data();
    try { basketLabel(info); } catch (e) {}
    try { addChips(info, p); } catch (e) {}
    try { moveServices(info); } catch (e) {}
    try { addContact(info); } catch (e) {}
    var specs = null;
    try { specs = splitDescription(info); } catch (e) {}
    try { addDetails(info, specs); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
